import { HotTopicConversationFilter } from '@conversed/shared/src/central/constants/hot-topics';
import { z } from 'zod';

export const HotTopicConversationSummarySchema = z.object({
  _id: z.string(),
  question: z.string(),
  answer: z.string(),
});

export const HotTopicConversationSummariesResponseSchema = z.object({
  results: z.array(HotTopicConversationSummarySchema),
  totalRecords: z.number(),
});

export const HotTopicOverviewItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  isDeleted: z.boolean(),
  volume7d: z.number(),
  preApprovedCount: z.number(),
  toReviewCount: z.number(),
  lastTrainedAt: z.string().nullable(),
});

export const HotTopicsOverviewResponseSchema = z.object({
  topics: z.array(HotTopicOverviewItemSchema),
  // Null when the pre-approval rate is not yet available (computed by a separate task).
  reviewAgentStatus: z
    .object({ preApprovedPercentage: z.number() })
    .nullable()
    .optional(),
  // Admin-configured bot name (platformSettings.botName), with Core LLM-block name as fallback
  botName: z.string(),
});

export const HotTopicConversationsQuerySchema = z.object({
  hotTopicId: z.string(),
  filter: z
    .enum(HotTopicConversationFilter)
    .optional()
    .default(HotTopicConversationFilter.ALL),
});

export const SetConversationHotTopicBodySchema = z.object({
  hotTopicId: z.string(),
});

export const SetConversationHotTopicParamsSchema = z.object({
  conversationId: z.string(),
});
